import React from 'react';

import CryptoJS from 'crypto-js';

export default class WidgetAES 
{
    /**
     * 用户密码加密
     * @param {*} password 用户密码
     * @param {*} nonce 6位随机数
     * @returns 
     */
    static encryptPassword(password, nonce)
    {
        let secret  = CryptoJS.MD5("EZ8*Sv" + nonce + "&6t-Ku").toString().toUpperCase();

        let key = secret.substring(0, 16);

        let iv = secret.substring(16, 32);

        let passwordSecret = this.encryptData(password, key, iv);

        return passwordSecret;
    }

    /**
     * 用户密码解密
     * @param {*} password 
     * @param {*} nonce 
     * @returns 
     */
    static decryptPassword(passwordSecret, nonce)
    {
        let secret  = CryptoJS.MD5("EZ8*Sv" + nonce + "&6t-Ku").toString().toUpperCase();

        let key = secret.substring(0, 16);

        let iv = secret.substring(16, 32);

        let password = this.decryptData(passwordSecret, key, iv);

        return password;
    }


    /**
     * AES加密算法
     * @param {*} input 输入字符创
     * @param {*} secretKey 
     * @param {*} iv 
     * @returns 
     */
    static encryptData(input, secretKey, iv)
    {
        const encryptData = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(input), CryptoJS.enc.Utf8.parse(secretKey), {
            iv:  CryptoJS.enc.Utf8.parse(iv),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });  
        
        return CryptoJS.enc.Hex.stringify(encryptData.ciphertext).toUpperCase();
    }

    /**
     * AES解密算法
     * @param {*} ciphertext 
     * @param {*} secretKey 
     * @param {*} iv 
     * @returns 
     */
    static decryptData(ciphertext, secretKey, iv) 
    {
        ciphertext = ciphertext.toLowerCase();
    
        const bytes = CryptoJS.AES.decrypt({ciphertext: CryptoJS.enc.Hex.parse(ciphertext)}, 
            CryptoJS.enc.Utf8.parse(secretKey), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        return bytes.toString(CryptoJS.enc.Utf8);
    }    
}